export default {

// main_site: 'http://192.168.0.40:9000/',
// web_local: 'http://192.168.0.40:9000/',
// apiv1: 'http://192.168.0.40:9001/api', // LOCAL

//   main_site: 'https://staging-portal.alsolutionsoftware.com/',
//   web_local: 'https://staging-portal.alsolutionsoftware.com/',
//   apiv1: 'https://staging-portal-api.alsolutionsoftware.com/api',

main_site: 'https://portal.alsolutionsoftware.com/',
web_local: 'https://portal.alsolutionsoftware.com/',
apiv1: 'https://portal-api.alsolutionsoftware.com/api',
  
  api_full_url: window.location.origin,
  bearer_token: `?token=${localStorage.getItem('token')}`,
  headers: {
      'Content-Type': 'application/json',
      'Accept' : 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
  },
  headers_tokenless: {
      'Content-Type': 'application/json',
      'Accept' : 'application/json',
      'Access-Control-Allow-Origin': '*'
  },

  //ENDPOINT FOR TESTING CONNECTION IN API
  api_status: '/api-status',

  //ENDPOINTS FOR DASHBOARD
  get_admin_dashboard: '/admin/dashboard/get-details',

  //ENDPOINTS FOR COMPANY
  get_companies: '/company/list-all',
  add_company: '/company/add',
  find_company: '/company/find',
  edit_company: '/company/edit',
  without_project_config: '/company/without-project-config',
  without_subscription_config: '/company/without-subscription-config',
  get_company_subscriptions: '/company/subscriptions',
  check_company_subscription: '/company/check-subscription',
  get_subscription_payments: '/company/subscription/payments',

  //ENDPOINTS FOR USER ACCOUNT
  login: '/login',
  refresh: '/refresh',
  logout: '/logout',
  
  add_user_account: '/user/register',
  find_user_account: '/user/find', 
  change_user_account_password: '/user/change-password',
  edit_user_account: '/user/edit',
  get_user_accounts: '/user/list-all',
  reactivate_user_account: '/user/reactivate',
  deactivate_user_account: '/user/deactivate',
  user_logout_key: '/user/logout/key',

  //ENDPOINTS FOR ADMIN
  add_admin_account: '/admin/register',
  get_admin_accounts: '/admin/listall',
  get_admin_accounts_without_user_role: '/admin/listall/without-user-role',
  reactivate_admin_account: '/admin/reactivate',
  deactivate_admin_account: '/admin/deactivate',
  upload_profile_picture_admin_account: '/admin/profile-picture/upload',
  change_admin_account_password: '/admin/change-password',

  //ENDPOINTS FOR PAYMENTS
  get_company_payments: '/payment/get',
  get_payments: '/payment/listall',
  view_payment_details: '/payment/view',

  //ENDPOINTS FOR SUBSCRIPTIONS
  // get_all_subscriptions: '/subscription/listall',
  // cancel_subscription: '/subscription/cancel',
  // check_subscription_expiration: '/subscription/check-expiration',
  // add_subscription: '/subscription/add',

  //ENDPOINTS FOR SUBSCRIPTION CONFIGURATION
  add_subscription_configuration: '/configuration/subscription/add',
  get_subscription_configuration: '/configuration/subscription/list-all',
  edit_subscription_configuration: '/configuration/subscription/edit',

  add_project_configuration: '/configuration/project/add',
  get_project_configuration: '/configuration/project/list-all',
  assign_company_project_configuration: '/configuration/project/company/assign',
  remove_company_project_configuration: '/configuration/project/company/remove',
  edit_project_configuration: '/configuration/project/edit',
  delete_project_configuration: '/configuration/project/delete',
  find_project_configuration: '/configuration/project/find',

  //ENDPOINTS FOR USER ROLE
  add_user_role: '/user-role/add',
  get_user_roles: '/user-role/listall',
  delete_user_role: '/user-role/delete',
  get_user_role_accounts: '/user-role/accounts',
  apply_user_role: '/user-role/apply',
  remove_user_role: '/user-role/remove',

  //ENDPOINTS FOR USER ROLE PERMISSIONS
  add_user_role_permissions: '/user-role/permissions/add',
  get_user_role_permissions: '/user-role/permissions/get',
  edit_user_role_permissions: '/user-role/permissions/edit',

  //ENDPOINTS FOR PAYPAL PAYMENT GATEWAY
  create_payment: '/paypal/create',
  success_payment: '/paypal/success',
  cancel_payment: '/paypal/cancel',

  //ENDPOINTS FOR DRAGONPAY PAYMENT GATEWAY
  create_dragonpay_payment: '/dragonpay/create',
  get_dragonpay_processors: '/dragonpay/processors',

  //ENDPOINTS FOR APP FEATURES & PERMISSIONS
  add_app_feature: '/app/feature/add',
  get_app_features: '/app/feature/listall',

  get_app_permissions: '/app/permission/listall',
  update_app_permissions: '/app/permission/update',

  // ENDPOINTS FOR LOGS
  get_auth_logs: '/logs/list-all',
  log_logout: '/logs/logout',
  log_logout_failed: '/logs/logout-failed',
  get_email_logs: '/logs/email/list-all',
  
  // ENDPOINTS FOR BILLINGS
  get_all_billings: '/billings/get',
  get_billing_details: '/billings/details',
  mark_billing_paid: '/billings/mark-as-paid',
  resend_billing_emails: '/billings/resend-email',
  get_company_billings: '/billings/company/get',

  // Owner portal — read-only billing resident details
  owner_get_billing_resident_details: '/billings/owner/resident-details',

  // ENDPOINTS FOR BILLING EMAIL CONFIGURATION
  get_billing_email_config:            '/configuration/billing-email/list-all',
  get_billing_email_config_by_company: '/configuration/billing-email/company',
  add_billing_email_config:            '/configuration/billing-email/add',
  edit_billing_email_config:           '/configuration/billing-email/edit',
  toggle_billing_email_config:         '/configuration/billing-email/toggle-status',
  delete_billing_email_config:         '/configuration/billing-email/delete',
}